import React, { Component } from 'react';
import OutOfPocketExpenseUI from './OutOfPocketExpenseUI';
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils';

class OutOfPocketExpenseSF extends Component {
  constructor(props) {
    super(props);
    this.state = {
      legalInvoiceUpdateMode: false,
      dateCreated: null,
      selectedCharge: null,
      invoiceNumber: '',
    };
  }

  render() {
    return (
      <OutOfPocketExpenseUI
        context={this.props.context}
        errorList={this.state.errorList}
        loan={this.props.loan}
        title={this.props.title}
        chargeType={this.props.chargeType}
        outOfPocketExpenses={this.props.outOfPocketExpenses}
        grandTotals={this.calculateGrandTotals(this.props.outOfPocketExpenses)}
        onAddChargesClick={this.props.onAddChargesClick}
        onRefreshClick={this.props.onRefreshClick}
        //
        onLegalInvoiceUpdateClick={this.onLegalInvoiceUpdateClick}
        //
        onDocDownloadClick={this.onDocDownloadClick}
        onFileDeleteClick={this.onFileDeleteClick}
        //
        onUploadClick={this.props.onUploadClick}
        //
      />
    );
  }

  calculateGrandTotals = (expenses) => {
    if (!expenses || expenses.length === 0) {
      return {
        totalCharges: 0,
        totalChargesFormatted: "0.00",
        totalPaid: 0,
        totalPaidFormatted: "0.00",
        totalRemaining: 0,
        totalRemainingFormatted: "0.00"
      };
    }

    let totalChargesAmount = 0;
    let totalPaidAmount = 0;

    expenses.forEach(charge => {
      totalChargesAmount += parseFloat(charge.amount) / 100;

      if (charge.paymentList && charge.paymentList.length > 0) {
        charge.paymentList.forEach(payment => {
          totalPaidAmount += parseFloat(payment.amount) / 100;
        });
      }
    });

    const totalRemainingAmount = Math.max(0, totalChargesAmount - totalPaidAmount);

    return {
      totalCharges: totalChargesAmount,
      totalChargesFormatted: totalChargesAmount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","),
      totalPaid: totalPaidAmount,
      totalPaidFormatted: totalPaidAmount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","),
      totalRemaining: totalRemainingAmount,
      totalRemainingFormatted: totalRemainingAmount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    };
  }

  onDocDownloadClick = (event) => {
    const loanId = event.currentTarget.getAttribute('data-loan-id');
    const invoiceNumber = event.currentTarget.getAttribute('data-invoice-number');
    const fileName = event.currentTarget.getAttribute('data-file-name');

    this.setState({ fileDownloadSubmitted: true });

    RestApiUtils.get(
      this.props.context,
      `/api/su/loans/${loanId}/charges/${invoiceNumber}/legalChargeInvoice/${fileName}/fileDownloadSignedUrl`,
      this.onDocDownloadClickCallback,
      null
    );
  };

  onDocDownloadClickCallback = (response) => {
    this.setState({
      fileDownloadSubmitted: false,
      fileErrorList: response.errorList
    });

    if (response.errorList.length === 0 && response.signedUrl && response.signedUrl.signedUrl) {
      const link = document.createElement('a');
      link.href = response.signedUrl.signedUrl;
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  onLegalInvoiceUpdateClick = (event, chargeData) => {
    let dateCreated = event.currentTarget.getAttribute('data-charge-create-id');
    let invoiceNumber = event.currentTarget.getAttribute('data-invoice-number');

    console.log("selected id:", dateCreated);
    console.log("selected charge:", chargeData);
    console.log("invoice number:", invoiceNumber);

    this.props.onLegalInvoiceUpdateClick(event, chargeData);
  }

  onFileDeleteClick = (event) => {
    if (this.state.deleteSubmitted) return;

    const invoiceNumber = event.currentTarget.getAttribute('data-invoice-number');
    const fileName = event.currentTarget.getAttribute('data-file-name');
    const loanId = this.props.loan.loanId;

    this.setState({
      deleteSubmitted: true,
      deleteErrorList: [],
      deleteSuccessMsg: null
    });

    RestApiUtils.delete(
      this.props.context,
      `/api/su/loans/${loanId}/charges/${invoiceNumber}/legalChargeInvoice/files/${encodeURIComponent(fileName)}`,
      this.onFileDeleteCallback
    );
  };

  onFileDeleteCallback = (response) => {
    var errorList = (response.errorList && response.errorList.map(function (err) {
      return err.message;
    })) || [];

    this.setState({
      deleteSubmitted: false,
      deleteSuccessMsg: response.success,
      deleteErrorList: errorList
    });

    if (errorList.length === 0) {
      // Invalidate the cache for the charge list before refreshing
      // const cacheKey = CacheKeys.OutOfPocketExpenses(this.props.loan.loanId);
      // CacheManager.invalidate && CacheManager.invalidate(cacheKey);
      setTimeout(() => {
        this.setState({ deleteSuccessMsg: null, deleteErrorList: [] });
        this.props.onRefreshClick();
      }, 2000);
    }
  }
}

export default OutOfPocketExpenseSF
